
import { LineChart, AlertCircle, Workflow, BookUser } from "lucide-react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

const ServicesMenu = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="text-white/80 hover:text-white bg-transparent hover:bg-transparent px-0 text-base">
            Services
          </NavigationMenuTrigger>
          <NavigationMenuContent className="bg-background/95 backdrop-blur-lg border border-white/10">
            <ul className="grid gap-3 p-4 md:w-[400px] grid-cols-1">
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/services/training"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <BookUser className="h-4 w-4 text-green-400" />
                      <div className="text-sm font-medium leading-none text-white">Training</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Self-paced modules, workshops, and 1-on-1 sessions
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/services/strategy"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <LineChart className="h-4 w-4 text-purple-400" />
                      <div className="text-sm font-medium leading-none text-white">Strategy</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Expert guidance on AI integration for legal practices
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/services/advisory"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <AlertCircle className="h-4 w-4 text-green-400" />
                      <div className="text-sm font-medium leading-none text-white">Advisory</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Ongoing support for navigating the AI landscape
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/services/custom-solutions"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Workflow className="h-4 w-4 text-amber-400" />
                      <div className="text-sm font-medium leading-none text-white">Custom Solutions</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Tailored AI workflows designed for your specific legal practice
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default ServicesMenu;
